/**
 * Specifies whether or not SettlCurrFxRate (155) should be multiplied or divided.
 * tag: 156
 * @readonly
 * @enum {string} (char)
 */
export enum SettlCurrFxRateCalc {
  /** Multiply */
  Multiply = 'M',
  /** Divide */
  Divide = 'D',
}
